import { type } from 'arktype';

export const DataFormat = type({
  selectors: type({
    timeline: 'string',
  }),
  title: 'string',
  showInTimeline: 'boolean',
});

export type DataFormat = typeof DataFormat.infer;
